module.exports = __webpack_public_path__ + "static/media/2.f7e6d2d2.gif";